import React, { PropsWithChildren } from "react";
import cx from "classnames";
import EditButton from "pages/Profile/components/common/EditButton";
import "./styles.scss";

interface Props {
  className?: string;
  iconClassName?: string;
  isEdit?: boolean;
  editBottom?: boolean;
  isLoading?: boolean;
  onClickEdit?: () => void;
}

const ProfileCard = ({
  children,
  className,
  iconClassName,
  isEdit,
  isLoading,
  editBottom,
  onClickEdit,
}: PropsWithChildren<Props>) => (
  <div className={cx("profile-card", { loading: isLoading }, className)}>
    {isEdit && !isLoading && (
      <EditButton
        onClick={onClickEdit}
        className={cx("card-edit", {
          "card-edit--top": !editBottom,
          "card-edit--bottom": editBottom,
        })}
        iconClassName={iconClassName}
      />
    )}
    {children}
  </div>
);

export default ProfileCard;
